<template>
    <TsCarouselV2 append-class="px-0" :loop="true" prev-button-class="top-[8.5rem]" next-button-class="top-[8.5rem]">
        <TsCarouselSlide append-class="p-0 lg:p-2 flex-[0_0_calc(100%/3)] min-w-[280px] max-w-max"
            v-for="{ data } in blogListData" :key="data.id">
            <TsCardYouMayAlsoLike :id="data?.id" :title="data?.title" :excerpt="data?.excerpt" :url="data?.url"
                :image="data?.blogImage" dataTestid="blog-card-you-may-also-like" />
        </TsCarouselSlide>
    </TsCarouselV2>
</template>

<script setup lang="ts">
const TsCardYouMayAlsoLike = defineAsyncComponent(() => import('~/components/organisms/TsCardYouMayAlsoLike.vue'));
const TsCarouselV2 = defineAsyncComponent(() => import('~/components/organisms/TsCarouselV2.vue'));
const TsCarouselSlide = defineAsyncComponent(() => import('~/components/organisms/TsCarouselSlide.vue'));

const runtimeConfig = useRuntimeConfig();
const i18n = useNuxtApp().$i18n.locale.value;
const builderApiKey = runtimeConfig.public.builderApiKey;
const { getBlogList } = await import("~/services-optimized/builderService");
const { data: blogListData } = await useAsyncData('blog-list', () => getBlogList(builderApiKey, {limit: 6, locale: i18n}));
</script>